module.exports = __webpack_public_path__ + "static/media/7-rectangle-unavailable.4885cb2a.svg";